export default function Contact() {
    return (
        <>
            <div className="container center" style={{ position: "fixed" }}>
                <p>Find me on <a href="https://www.linkedin.com/in/peter-vielberth" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </p>
                <p>Happy to connect!</p>
            </div>
        </>
    )
}
